import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function ProgressionSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-dark relative border-t border-brand-gold/10" data-id="element-113">
      <div className="max-w-5xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-115">
          <h2 className="font-heading font-bold text-3xl md:text-5xl uppercase tracking-tight text-brand-text mb-6" data-id="element-116">
            Primero atraes, luego das seguimiento,{' '}
            <span className="text-brand-gold" data-id="element-117">Después escalas</span>
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0 mb-10 relative" data-id="element-118">
          {/* Connecting Line for Desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-gold/20 -z-10 transform -translate-y-1/2" data-id="element-119"></div>

          {[{
          step: 'BUILD',
          desc: 'Control sobre la atracción'
        }, {
          step: 'TRACK',
          desc: 'Control sobre la activación'
        }, {
          step: 'SCALE',
          desc: 'Control sobre el crecimiento'
        }].map((item, index) => <Fragment key={index} data-id="element-120">
              <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-brand-white border-2 border-brand-gold p-4 rounded-xl w-full md:w-64 text-center shadow-[0_0_20px_rgba(200,149,43,0.1)] relative z-10" data-id="element-121">
                <h3 className="font-heading font-bold text-2xl text-brand-gold mb-2" data-id="element-122">
                  {item.step}
                </h3>
                <p className="text-brand-text-muted text-sm" data-id="element-123">{item.desc}</p>
              </motion.div>

              {index < 2 && <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2 + 0.1
          }} className="md:hidden my-4" data-id="element-124">
                  <ArrowRightIcon className="w-8 h-8 text-brand-gold transform rotate-90" data-id="element-125" />
                </motion.div>}
              {index < 2 && <div className="hidden md:flex items-center justify-center w-12 h-12 bg-brand-white rounded-full border border-brand-gold/30 z-10 shadow-sm" data-id="element-126">
                  <ArrowRightIcon className="w-6 h-6 text-brand-gold" data-id="element-127" />
                </div>}
            </Fragment>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-128">
          <p className="text-lg text-brand-text-muted leading-relaxed" data-id="element-129">
            No todos necesitan empezar en el mismo punto. Pero la progresión
            está diseñada para que tu operación avance con orden:{' '}
            <span className="text-brand-text font-semibold" data-id="element-130">
              atraer, activar y escalar.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}